import React, {Fragment} from "react";
import {useSelector} from "react-redux";
import {Col, Row} from "react-bootstrap";
import {CaseFormField} from "../../CaseGenerator";
import {UserRoleEnum} from "../../../../helpers/enums";
import {TranslatedText} from "../../../../helpers/helpers";

const LayoutComponentWithComunalOperatorCheck = (props) => {
  const {layout, fields} = props;
  const {fields: layoutFields} = layout;
  const user = useSelector((state) => state.auth);
  const {userFetched} = user;
  const role = user.profile.role;

  const isConditionMet = (conditionProps) => {
    if (!conditionProps) {
      return true;
    }
    const conditions = conditionProps;
    if (conditions.length === 0) {
      return true;
    }

    let allowed = false;
    conditions.forEach(condition => {
      if (userFetched && (role === condition.is)) {
        allowed = true;
      }
    });
    return allowed;
  };
  return (
    <Fragment key={layout.title}>
      {!layout.noMandatoryLegend && (
        <p className={"case-step-mandatory-fields-legend paragraph-small-fs9"}><TranslatedText i18nKey="mandatory.fields.legend"/></p>
      )}
      {layout.title && <h2 className={'case-step-title'}>{layout.title}</h2>}
      {layout.description && <p className={'case-step-description'}>{layout.description}</p>}
      <Row>
        {
          layoutFields && layoutFields.map((item, index) => {
            const gridProps = item.grid;
            const conditionProps = item.condition || null;
            let fieldProps = fields[item.fieldName];
            if (fieldProps && role === UserRoleEnum.MUNICIPAL_OPERATOR) {
              if (item.fieldName === 'campo_contract') {
                fieldProps = {
                  name: "campo_contract",
                  label: <TranslatedText i18nKey="cases.contract-select.label"/>,
                  placeholder: <TranslatedText i18nKey="cases.contract-select.select-contract"/>,
                  requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required"/>,
                  readonly: false,
                  type: "input",
                }
              } else {
                fieldProps.readonly = false;
              }
            }
            const conditionMet = isConditionMet(conditionProps);
            return conditionMet && (
              <Col {...gridProps} key={index}>
                {!item.fieldName && <h3 className="form-section-title">{item.text}</h3>}
                {item.fieldName && <CaseFormField {...fieldProps} />}
              </Col>
            )
          })
        }
        {
          layout.content && <div className="col-12">
            <div className={'content'}>{layout.content}</div>
          </div>
        }
      </Row>
    </Fragment>
  );
}

export default LayoutComponentWithComunalOperatorCheck;
